import incantationTote from '../../assets/incantation-tote-Bag.png'
import incantationTee from '../../assets/incantation-tshirt.png'
import incantationArt from '../../assets/incantation-album-art.jpg'
import WWLArt from '../../assets/WWL-art.jpg'

const merch = [
  {
    title: 'Incantation 12" Vinyl - Limited Edition',
    image: incantationArt,
    link: 'https://janetteking.bandcamp.com/album/incantation',
  },
  {
    title: 'Incantation T-Shirt',
    image: incantationTee,
    link: 'https://janetteking.bandcamp.com/merch/black-history-month-deal',
  },
  {
    title: 'Incantation Tote Bag',
    image: incantationTote,
    link: 'https://janetteking.bandcamp.com/merch/tote-bag',
  },
  {
    title: 'What We Lost LP 12" Vinyl',
    image: WWLArt,
    link: 'https://janetteking.bandcamp.com/album/what-we-lost',
  },
]

export default merch
